import { defineComponent, Types } from 'bitecs';

export const Border = defineComponent({
  color: Types.ui32,
  padding: Types.f32,
  thickness: Types.f32,
  transition: Types.f32,
  initialized: Types.ui8,
  lineTop: Types.eid,
  lineRight: Types.eid,
  lineBottom: Types.eid,
  lineLeft: Types.eid,
});
